module.exports = __webpack_public_path__ + "media/images/icons/pulse-43c00ec1c4fda7f28d885c8dbbfd96f8.svg";